import { getItems } from 'common/api/winds';

import {
    FETCH_ITEMS,
    FETCH_ITEMS_FAILURE,
    FETCH_ITEMS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default ({ country, orderBy, page = 0, pageSize, search, sort } = {}) =>
    (dispatch) => {
        dispatch(actions[FETCH_ITEMS]());

        getItems({
            country,
            orderBy,
            page: page + 1,
            perPage: pageSize,
            search,
            sort,
        })
            .then((response) =>
                dispatch(actions[FETCH_ITEMS_SUCCESS](response.data)),
            )
            .catch((error) =>
                dispatch(
                    actions[FETCH_ITEMS_FAILURE](error?.response?.data?.errors),
                ),
            );
    };
